import { DesignTokenSizeEnum } from '../theme-provider';
export { DesignTokenSizeEnum as ContainerGutter };
/**
 * @deprecated The ContainerWrap enum is deprecated. Please use the string values instead.
 */
export var ContainerWrap;
(function (ContainerWrap) {
    ContainerWrap["never"] = "never";
    ContainerWrap["always"] = "always";
    ContainerWrap["auto"] = "auto";
})(ContainerWrap || (ContainerWrap = {}));
export { DesignTokenSizeEnum as ContainerPadding };
/**
 * @deprecated The ContainerHorizontalAlignment enum is deprecated. Please use the string values instead.
 */
export var ContainerHorizontalAlignment;
(function (ContainerHorizontalAlignment) {
    ContainerHorizontalAlignment["flexStart"] = "flex-start";
    ContainerHorizontalAlignment["center"] = "center";
    ContainerHorizontalAlignment["flexEnd"] = "flex-end";
    ContainerHorizontalAlignment["spaceBetween"] = "space-between";
})(ContainerHorizontalAlignment || (ContainerHorizontalAlignment = {}));
/**
 * @deprecated The ContainerVerticalAlignment enum is deprecated. Please use the string values instead.
 */
export var ContainerVerticalAlignment;
(function (ContainerVerticalAlignment) {
    ContainerVerticalAlignment["flexStart"] = "flex-start";
    ContainerVerticalAlignment["center"] = "center";
    ContainerVerticalAlignment["flexEnd"] = "flex-end";
})(ContainerVerticalAlignment || (ContainerVerticalAlignment = {}));
